import { render, staticRenderFns } from "./vuetify-phone-number-input.vue?vue&type=template&id=282f4862&scoped=true&"
import script from "./vuetify-phone-number-input.vue?vue&type=script&lang=js&"
export * from "./vuetify-phone-number-input.vue?vue&type=script&lang=js&"
import style0 from "./vuetify-phone-number-input.vue?vue&type=style&index=0&id=282f4862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282f4862",
  null
  
)

/* custom blocks */
import block0 from "./vuetify-phone-number-input.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
